import { render, staticRenderFns } from "./CardTraceability.vue?vue&type=template&id=b5a3b74e"
import script from "./CardTraceability.vue?vue&type=script&lang=js"
export * from "./CardTraceability.vue?vue&type=script&lang=js"
import style0 from "./CardTraceability.vue?vue&type=style&index=0&id=b5a3b74e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports